module.exports = __webpack_public_path__ + "static/media/01.494ad63d.jpg";